











import { Component, mixins } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import useSize, { useSizeMixin } from '@/modules/shared/mixins/useSize'

const useSizeDefaults = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18
}

@Component
export default class RemovableBadge extends mixins<useSizeMixin>(
  useSize(useSizeDefaults)
) {
  @Prop({ default: '' }) readonly label!: string

  @Prop({
    default: false
  }) noIcon!: boolean
}
